import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import LanguageSwitcher from '../LanguageSwitcher';
import smlogo from '../../images/logo/4S Mapper_LOGO_Signature.png';
import dromiilogo from '../../images/logo/DroMii_logo.png';

const Header = () => {
  const { t } = useTranslation('header');
  const [showHeader, setShowHeader] = useState(true);
  const [bgWhite, setBgWhite] = useState(false);
  const lastScrollY = useRef(0);
  const location = useLocation();
  const navigate = useNavigate();
  const isRoot = location.pathname === '/';

  // ✅ 스크롤 시 헤더 색상 / 숨김 처리
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY.current && currentScrollY > 50) {
        setShowHeader(false);
      } else {
        setShowHeader(true);
      }
      lastScrollY.current = currentScrollY;

      if (isRoot) {
        setBgWhite(currentScrollY > 300);
      } else {
        setBgWhite(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isRoot]);

  // ✅ 로고 클릭 시 최상단 이동
  const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      // 메인에 있을 때 → 스크롤만 맨 위로
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // 다른 페이지에 있을 때 → 메인으로 이동
      navigate('/');
      // 렌더 완료 후 살짝 딜레이 후 스크롤 보정
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'auto' }), 50);
    }
  };

  return (
    <div
      className={`HeaderContainer ${showHeader ? '' : 'hide'} ${
        bgWhite ? 'bg-white' : 'bg-transparent'
      }`}
    >
      <div className="HeaderContents">
        {/* ✅ 로고 클릭 시 최상단 이동 */}
        <div className="navbox" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <img src={smlogo} className="smlogo" alt="4SMapper logo" />
        </div>

        <NavLink
          to="/Platform"
          className={({ isActive }) => (isActive ? 'navbox active-link' : 'navbox')}
        >
          {t('nav.platform')}
        </NavLink>

        <NavLink
          to="/Solution"
          className={({ isActive }) => (isActive ? 'navbox active-link' : 'navbox')}
        >
          {t('nav.solution')}
        </NavLink>

        <NavLink
          to="/Products"
          className={({ isActive }) => (isActive ? 'navbox active-link' : 'navbox')}
        >
          {t('nav.products')}
        </NavLink>

        <NavLink
          to="/About"
          className={({ isActive }) => (isActive ? 'navbox active-link' : 'navbox')}
        >
          {t('nav.about')}
        </NavLink>

        <NavLink
          to="/Contact"
          className={({ isActive }) => (isActive ? 'contactbox active-contact' : 'contactbox')}
        >
          {t('nav.contact')}
        </NavLink>

        <LanguageSwitcher />

        <a href="https://new.dromii.com/" target="_blank" rel="noopener noreferrer">
          <img src={dromiilogo} className="dromiilogo" alt="DroMii logo" />
        </a>
      </div>
    </div>
  );
};

export default Header;
